'use strict';

var getInferredName;
try {
	// eslint-disable-next-line no-new-func
	getInferredName = Function('s', 'return { [s]() {} }[s].name;');
} catch (e) {}

var inferred = function () {};
module.exports = getInferredName && inferred.name === 'inferred' ? getInferredName : null;




//////////////////
// WEBPACK FOOTER
// ./node_modules/symbol.prototype.description/helpers/getInferredName.js
// module id = 160
// module chunks = 22